import { parseResponseError } from '../../../../common/helpers';
import { DatasourceReturnType, ResponseError, ResponseList } from '../../../../models';
import { F1PasswordManagement, GetF1PasswordManagementRequest, UpdateF1PasswordManagementRequest } from '../schemas';
import { getAll, updateF1PasswordConfig } from '../datasources/f1passwordManagement.datasource';

export async function getF1PasswordManagement(
    params: GetF1PasswordManagementRequest
): Promise<DatasourceReturnType<ResponseError, F1PasswordManagement[]>> {
    try {
        const data = (await getAll(params)).data;

        return [null!, data];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}

export async function updateF1PasswordManagement(
    body: UpdateF1PasswordManagementRequest
): Promise<DatasourceReturnType<ResponseError, string>> {
    try {
        const data = (await updateF1PasswordConfig(body)).data;

        return [null!, data];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}
